export function formatQueryError({ name, message }) {
  return { error_name: name, error_message: message };
}

export function parseQueryError({ error_name, error_message }) {
  return { name: error_name, message: error_message };
}
